// extracted by mini-css-extract-plugin
export default {"container":"accessDeniedStyle_container__4DIYb","img":"accessDeniedStyle_img__N3RRe","label":"accessDeniedStyle_label__t+oNn","description":"accessDeniedStyle_description__bIALj"};